import { useEffect, useState } from "react";
import { kpsiGet, kpsiPost } from "./kpsiApi";

type Row = {
  id: number;
  email?: string;
  fullName: string;
  companyAccessCount: number;
};

interface Props {
  onEdit: (id: number) => void;
  onAdd: () => void;
  onFlash: (msg: string) => void;
}

export default function KpsiUsersList({ onEdit, onAdd, onFlash }: Props) {
  const [rows, setRows] = useState<Row[]>([]);

  async function load() {
    const data = await kpsiGet<{ rows: Row[] }>("/Kpsi/Operators");
    setRows(data.rows ?? []);
  }

  useEffect(() => {
    void load().catch((e) => onFlash(e instanceof Error ? e.message : "Load failed"));
  }, [onFlash]);

  async function onRemove(id: number) {
    await kpsiPost(`/Kpsi/Operators/${id}/Remove`);
    onFlash("Removed KPSI access for user (RightTime account kept).");
    await load();
  }

  return (
    <>
      <div className="kpsi-toolbar">
        <h1>Manage Users</h1>
        <div className="ms-auto">
          <button type="button" onClick={onAdd}>Add KPSI Operator</button>
        </div>
      </div>
      <p className="kpsi-muted">
        Name, email, and password are managed in RightTime. This screen configures Interpreter / Scorer access for KPSI companies.
      </p>
      <table className="kpsi-records">
        <thead>
          <tr>
            <th>Name</th>
            <th>Email</th>
            <th>Companies with access</th>
            <th>Actions</th>
          </tr>
        </thead>
        <tbody>
          {rows.map((r) => (
            <tr key={r.id}>
              <td>{r.fullName}</td>
              <td>{r.email}</td>
              <td>{r.companyAccessCount}</td>
              <td className="actions">
                <button type="button" onClick={() => onEdit(r.id)}>Configure access</button>
                {" | "}
                <button type="button" onClick={() => void onRemove(r.id)}>Remove from KPSI</button>
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </>
  );
}
